import { Handle, Position, type NodeProps } from "@xyflow/react";
import { XCircle } from "@untitledui/icons";
import { useTranslation } from "react-i18next";

export const EndNode = ({ data }: NodeProps) => {
    const { t } = useTranslation('pages:workflows-admin');
    const label = (data?.label as string) || t('workflows.editor.defaultLabels.end');
    return (
        <div className="rounded-lg bg-utility-error-50 border-2 border-utility-error-500 shadow-md min-w-[120px]">
            <Handle type="target" position={Position.Top} className="w-3 h-3 bg-utility-error-500" />
            <div className="flex items-center gap-2 px-3 py-2">
                <XCircle className="size-4 text-utility-error-600" />
                <span className="text-sm font-semibold text-utility-error-700">{label}</span>
            </div>
        </div>
    );
};
